import { TransformType } from '../../constant';
import React from 'react';
const transformTypeStringShort = (type: TransformType): any => {
    let uiitemicon = {
        display: 'inline-block',
        border: '1px solid #72b148',
        borderRadius: 3,
        color: '#72b148',
        'text-align': 'center',
        'line-height': 18,
        height: 18,
        width: 16,
        marginRight: 2,
        fontSize: 12,
    };
    switch (type) {
        case TransformType.增值税专用发票:
            return <div><div style={uiitemicon}>专</div>增值税专用发票</div>;
        case TransformType.增值税电子专用发票:
            return <div><div style={uiitemicon}>专</div>增值税电子专用发票</div>;
        case TransformType.增值税普通发票INVOICE:
            return <div><div style={uiitemicon}>普</div>增值税普通发票</div>;
        case TransformType.增值税普通发票卷票:
            return <div><div style={uiitemicon}>卷</div>增值税普通发票(卷票)</div>;
        case TransformType.增值税电子普通发票:
            return <div><div style={uiitemicon}>电</div>增值税普通发票(电票)</div>;
        case TransformType.机动车销售统一发票:
            return <div><div style={uiitemicon}>机</div>机动车销售统一发票</div>;
        case TransformType.二手车销售统一发票:
            return <div><div style={uiitemicon}>二</div>二手车销售统一发票</div>;
        case TransformType.货运运输业增值税专用发票:
            return <div><div style={uiitemicon}>货</div>货票</div>;
        case TransformType.通行费发票:
            return <div><div style={uiitemicon}>通</div>增值税普通发票(通行费)</div>;
        case TransformType.全电专票:
            return <div><div style={uiitemicon}>全</div>全电发票（增值税专用发票）</div>;
        case TransformType.全电普票:
            return <div><div style={uiitemicon}>全</div>全电发票（普通发票）</div>; 
        default:
            return '增值税普通发票';
    }
};
export default transformTypeStringShort;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/Language/transformTypeStringShort/index.tsx